import React, { lazy, Suspense, useEffect } from 'react'
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom'
import ROUTES from 'constants/routes'

// Redux
import { useDispatch, useSelector } from 'react-redux'
import { loadUserInfo, cleanUserInfo } from 'store/user/info'

import ScrollToTop from 'components/Shared/ScrollToTop'
import Login from 'components/Login'
import Toast from 'components/Shared/Toast'
import PostLoginOnboardingOrchestrator from 'components/Onboarding/PostLoginOnboardingOrchestrator'
import PrivateRoute from './Shared/PrivateRoute'
import Facilitators from './Facilitators/Facilitators'
import UserHome from './UserHome'
import GameSelection from './GameSelection'
import Lobby from './Lobby'

const MainBoard = lazy(() => import('components/MainBoard'))

function App() {
  const dispatch = useDispatch()

  const loggedIn = useSelector((store) => store.auth.loggedIn)

  useEffect(() => {
    if (loggedIn) {
      dispatch(loadUserInfo())
    }

    return () => {
      dispatch(cleanUserInfo())
    }
  }, [loggedIn])

  return (
    <Router basename="/">
      <Toast />
      <PostLoginOnboardingOrchestrator />
      <ScrollToTop>
        <Switch>
          <Route path={ROUTES.APP_URL_LOGIN}>
            <Login />
          </Route>
          <PrivateRoute path={ROUTES.APP_URL_FACILITATORS}>
            <Facilitators />
          </PrivateRoute>
          <PrivateRoute path={ROUTES.APP_URL_USER_HOME}>
            <UserHome />
          </PrivateRoute>
          <PrivateRoute path={ROUTES.APP_URL_GAME_SELECTION}>
            <GameSelection />
          </PrivateRoute>
          <PrivateRoute path={ROUTES.APP_URL_LOBBY}>
            <Lobby />
          </PrivateRoute>
          <PrivateRoute path={ROUTES.APP_URL_HOME}>
            <Suspense
              fallback={
                <div className="loading-page">
                  <span className="loading-page__text">Let&apos;s Roll</span>
                </div>
              }
            >
              <MainBoard />
            </Suspense>
          </PrivateRoute>
          <Route path="/">
            <Redirect to={ROUTES.APP_URL_LOGIN} />
          </Route>
        </Switch>
      </ScrollToTop>
    </Router>
  )
}

export default App
